// extracted by mini-css-extract-plugin
var _1 = "CommentWarning-module__animateUploadProgressBarWidth--Jsu81";
var _2 = "CommentWarning-module__animatedBackground--mxRLJ";
var _3 = "CommentWarning-module__container--mzrT4";
var _4 = "CommentWarning-module__content--FhGam";
var _5 = "CommentWarning-module__icon--_ne1p";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "icon" }
